import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchTatReports = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee"),
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise"),
  );

  const { no_limit, ...restFilter } = filter;

  const params = {
    zone_id,
    ...restFilter,
    f_franchise_id,
    f_is_super_franchise,
    f_is_franchise_employee,
    ...(no_limit ? { no_limit } : { limit, page_no }),
  };

  return axiosInstance.get(EndPoints.TAT_REPORT.LIST, { params });
};

export const fetchTatGraphicalReports = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee"),
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise"),
  );

  const { no_limit, group_by_report, ...restFilter } = filter;

  const params = {
    zone_id,
    ...restFilter,
    f_franchise_id,
    f_is_super_franchise,
    f_is_franchise_employee,
    ...(no_limit ? { no_limit } : { limit, page_no }),
    ...(group_by_report && group_by_report !== "ALL" && { group_by_report }),
  };

  return axiosInstance.get(EndPoints.TAT_REPORT.LIST_GRAPHICAL, {
    params,
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v));
        } else if (value !== undefined && value !== null && value !== "") {
          searchParams.append(key, value);
        }
      });

      return searchParams.toString();
    },
  });
};
